

















































































































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {Option, SegmentationResource} from '@/types/gripper';
import TaskElaboration from '@/layouts/gripper/components/TaskElaboration.vue';
import {
  DeleteJobResourceInput,
  JobDatasetSegmentation, JobDatasetSegmentation_job_dataset_resources_data, JobInfo,
  JobInfo_job_task_parameter,
} from '@/types/intrador';
import IntradorLoader from '@/layouts/gripper/components/QuickLabeling/IntradorLoader.vue';
import {SmartQuery} from 'vue-apollo/types/vue-apollo';
import PaginateButtonsShrinkingBin from '@/layouts/gripper/components/QuickLabeling/PaginateButtonsShrinkingBin.vue';
import DirectionSwitch from '@/layouts/back-office/misc/DirectionSwitch.vue';
import OptionButtonBar from '@/layouts/gripper/components/QuickLabeling/OptionButtonBar.vue';
import ImageSegmentation from '@/layouts/gripper/components/ImageSegmentation.vue';


@Component({
  components: {
    OptionButtonBar,
    TaskElaboration,
    IntradorLoader,
    PaginateButtonsShrinkingBin,
    DirectionSwitch,
    ImageSegmentation,
  },
})

export default class CanvasSegmentationContiniousMode extends Vue {
  @Prop(Object) public jobInfo!: JobInfo;
  @Prop(Array) public options!: Option[];
  @Prop(Object) private parameter!: JobInfo_job_task_parameter;
  private resource: SegmentationResource | null = null;
  private resources: SegmentationResource[] = [];
  private selectedParameterOption: Option | null = null;
  private selectedAnnotation: number = -1;

  private JobDataset!: JobDatasetSegmentation;
  private page: number = 1;
  private limit: number = 10;
  private lastPage: number = 0;
  private onlyNew: boolean = true;
  private drawBoxes: boolean = true;

  private brushSizeOptions = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 14, 18, 24, 30];
  private brushSize = 7;
  private opacity: number = 50;

  private deleteMode = false;

  private fill() {
    (this.$refs.imageSegmentation as any).fillLastPath();
  }

  private save() {
    (this.$refs.imageSegmentation as any).save();
  }

  private undo() {
    (this.$refs.imageSegmentation as any).undo();
  }

  private deleteSelectedAnnotation() {
    (this.$refs.imageSegmentation as any).deleteSelectedAnnotation();
  }

  private editSelectedAnnotation() {
    (this.$refs.imageSegmentation as any).editSelectedAnnotation();
  }

  private created() {
    if (this.options.length > 0) {
      this.selectedParameterOption = this.options[0];
    }

    this.onlyNew = this.$router.currentRoute.query.onlyNew === 'true';
    this.page = this.isInt(this.$router.currentRoute.query.page) ?
      parseInt(this.$router.currentRoute.query.page.toString(), 0) : 1;
  }

  private isInt(str: any) {
    return !isNaN(str) && Number.isInteger(parseFloat(str));
  }

  private setAnnotations(index: number) {
    this.selectedAnnotation = index;
  }

  private setDeleteMode(deleteMode: boolean) {
    this.deleteMode = deleteMode;
  }

  private getCategoryName(categoryId: number) {
    const category = this.options.find((option: Option) => {
      return option.id != null && parseInt(option.id, 0) === categoryId;
    });
    return ((category?.value || categoryId) as string);
  }

  private getAnnotations() {
    if (this.resource && this.resource.check_value) {
      return JSON.parse(this.resource.check_value);
    }
    return [];
  }

  private changeOption(option: Option) {
    this.selectedParameterOption = option;
  }

  private changeResource(resource: SegmentationResource) {
    (this.$refs.imageSegmentation as any).init(resource);
    this.resource = resource;
  }

  private resolveData(data: JobDatasetSegmentation) {
    if (!data || !data.job || !data.job.dataset || !data.job.dataset.resources) {
      return false;
    }

    this.JobDataset = data;
    this.lastPage = data.job.dataset.resources.paginatorInfo.lastPage;

    this.resources = data.job.dataset.resources.data.map(this.resolveResourceData) as SegmentationResource[];
    this.resource = this.resources[0] as SegmentationResource;
    return this.resource;
  }

  private resolveResourceData(item: JobDatasetSegmentation_job_dataset_resources_data): SegmentationResource {
    let predValue = null;
    let checkValue = null;
    if (item.predictions && item.predictions.length > 0) {
      if (item.predictions[0]) {
        predValue = item.predictions[0].value;
      }
    }

    if (item.checks && item.checks.length > 0) {
      if (item.checks[0]) {
        checkValue = item.checks[0].value;
      }
    }

    return {
      id: item.id,
      url: item.url + '?job_id=' + this.JobDataset.job?.id,
      check_value: checkValue,
      pred_value: predValue,
      isMutating: false,
      isDeleted: false,
    } as SegmentationResource;
  }

  get queryVariables() {
    return {
      jobID: this.jobInfo!.job!.id,
      page: this.page,
      limit: this.limit,
      parameter_id: this.onlyNew ? this.parameter.id : null,
      checkInputs: this.onlyNew ? [{
        has: false,
        parameter_id: this.parameter.id,
      }] : [],
    };
  }

  private async pageChange(newPage: number) {
    if (newPage === this.page) {
      return false;
    }

    this.page = newPage;
    this.$router.push({
      path: this.$router.currentRoute.path, query:
        {onlyNew: this.onlyNew.toString(), page: newPage.toString()},
    });
    this.refetch();
  }

  private get queryResult(): SmartQuery<any> {
    return (this.$refs.apolloQuery as any).getApolloQuery();
  }

  private refetch() {
    this.resource = null;
    if (this.queryResult) {
      this.queryResult.refresh();
    }
  }

  private remove() {
    if (this.resource && confirm('Are you sure?')) {
      this.deleteFromDataset(this.resource);
      this.refetch();
    }
  }

  private deleteFromDataset(resource: SegmentationResource) {
    const variables: DeleteJobResourceInput = {
      job_id: this.JobDataset.job?.id,
      resource_id: resource.id.toString(),
    } as DeleteJobResourceInput;
    this.$apollo.mutate({
      mutation: require('@/graphql/mutations/DeleteJobResource.graphql'),
      variables: {input: variables},
    }).catch((error) => {
      this.$swal('Error', error.message, 'warning');
    });
  }

  @Watch('onlyNew')
  private putOnlyNewInURL() {
    if ((this.$router.currentRoute.query.onlyNew === 'true') !== this.onlyNew) {
      this.page = 1;
      this.$router.push({
        path: this.$router.currentRoute.path, query:
          {onlyNew: this.onlyNew.toString(), page: this.page.toString()},
      });
    }
  }

}
